import { Platform, StatusBar, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'
import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Purple'],
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  body: { flex: 1, paddingHorizontal: 24 },
  backButton: { paddingVertical: 20 },
  header: {
    width: '100%',
    height: Platform.OS === 'ios' ? 55 : 45,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center'
  },
  question: {
    marginTop: 48,
    fontWeight: '400',
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#121212',
    fontSize: 28,
    lineHeight: 34
  },
  optionView: {
    borderRadius: 5,
    width: '100%',
    height: 50,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  optionText: {
    color: '#121212',
    fontWeight: '400',
    fontSize: 18,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  radioIcon: { height: 16, width: 16, resizeMode: 'contain', marginHorizontal: 16 },
  buttonStyle: {
    height: moderateScale(48),
    width: '100%',
    borderRadius: 48,
    position: 'absolute',
    bottom: 25,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  buttonView: {
    paddingHorizontal: 40,
    alignSelf: 'center',
    padding: 2
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  loadingStyle: {
    width: 20,
    height: 20,
    right: 0,
    position: 'absolute',
    top: 3
  },
  discription: {
    color: 'gray',
    fontWeight: '400',
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    marginVertical: 5
  }
})
